import React from "react";

const ServicePlan = () => {
    return (
        <>
        <section>
             <div
      className="w-full h-[60vh] flex justify-center items-center"
      style={{
        background: 'linear-gradient(to right, #fff1c6, #cccccc, #dac587, #f2fded)',
        animation: 'gradientBackground 15s ease infinite',
      }}
    >
      <div className=" custom-padding xl-screen-padding text-center">
        <h1 className="text-3xl md:text-4xl font-semibold text-gray-800">
          At Nutrillion, we empower you to take control of your health through science-backed nutrition strategies. Your journey to a healthier, more balanced life begins here.
        </h1>
      </div>
    </div>
        </section>
        <div className="custom-padding xl-screen-padding mx-auto pt-80 pb-80 ">
            <h2 className="text-2xl md:text-3xl text-center font-semibold client-text  mb-16">
                Why Choose <span className="text-yellow-700">Nutrillion’s Personalised Nutrition </span> Over Generic Plans?
            </h2>
            <div className="bg-[#f2f0ed] rounded-[30px]  p-6 grid grid-cols-1 md:grid-cols-2">
            <div className="pr-4 sm:pr-6 md:pr-8 border-r-4 border-gray-200 text-center mt-8 custom-service-line">
            <h3 className="text-xl font-bold text-black mb-16 client-text generic-text">Generic Nutrition Plan</h3>
                    <p className="text-gray-600 mb-16 font-lato text-p">One-size-fits-all, weight loss-centric.</p>
                    <p className="text-gray-600 mb-16 font-lato text-p">No advanced testing, generic advice.          </p>
                    <p className="text-gray-600 mb-16 font-lato text-p">Standard meal plans with limited adaptability.</p>
                    <p className="text-gray-600 mb-16 font-lato text-p">Minimal support, generic check-ins.                    </p>
                    <p className="text-gray-600 mb-16 font-lato text-p">Short-term focus on weight loss.
                    </p>
                    <p className="text-gray-600 mb-16 font-lato text-p">Temporary results with little
                        long-term impact.</p>
                    <p className="text-gray-600 mb-16 font-lato text-p">Rigid plans, little room for flexibility.                    </p>
                    <p className="text-gray-600 mb-16 font-lato text-p">Unsustainable long-term impact.                    </p>
                </div>

                <div className="pl-6 divider-services text-center mt-8">
                    <h3 className="text-xl font-bold text-yellow-700 mb-16 client-text generic-text">Nutrillion’s Personalised Nutrition Plan</h3>
                    <p className="text-black-600 mb-16 font-lato text-p">Customised approach based on genetic
                        & gut analysis.</p>
                    <p className="text-black-600 mb-16 font-lato text-p">Includes Nutrigenomics & Gut Microbiome
                        testing.</p>
                    <p className="text-black-600 mb-16 font-lato text-p">Weekly refined plans, tailored to
                        ongoing progress.</p>
                    <p className="text-black-600 mb-16 font-lato text-p">Dedicated team with weekly
                        monitoring & expert guidance.</p>
                    <p className="text-black-600 mb-16 font-lato text-p">Sustainable 6-month roadmap
                        for holistic health.</p>
                    <p className="text-black-600 mb-16 font-lato text-p">Focus on overall well-being, gut health,
                        and metabolic balance.</p>
                    <p className="text-black-600 mb-16 font-lato text-p">Fully adaptable programs based on
                        evolving health needs.</p>
                    <p className="text-black-600 mb-16 font-lato text-p">Designed for lifelong integration
                        and lifestyle enhancement.</p>
                </div>

            </div>
        </div>
        </>
    );
};

export default ServicePlan;
